import React from 'react';
import { ChevronRight as LucideChevronRight } from 'lucide-react';

interface ChevronRightProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const ChevronRight: React.FC<ChevronRightProps> = ({ width = 12, height = 12, className, style }) => (
  <LucideChevronRight width={width} height={height} className={className} style={style} aria-hidden strokeWidth={1.5} />
);

export default ChevronRight;
